export default __webpack_public_path__ + "static/media/8.961aa98d.webp";